(function () {
    'use strict';
    var m = angular.module('app');
    m.directive('topPanelFull', ["path", "routeHelper", "feature", "sideMenuManager", "$cookies", "autologinHelper", function (path, routeHelper, feature, sideMenuManager, $cookies, autologinHelper) {
        var imagesRoot = path('gui-v2').directive('side-menu-v2');
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('main').directive('top-panel-full').template(),
            scope: {},
            link: function ($scope, element, attrs) {
                var autologinCP = autologinHelper.enabled() || $cookies.get('autologinCP');
                $scope.visible = function () {
                    return !_(sideMenuManager.currentUser()).isEmpty() && !autologinCP;
                };
                $scope.sideMenuManager = sideMenuManager;
                $scope.logoHref = routeHelper.pathToHref('/');
                feature.init(true, true).then(function () {
                    if (feature.checkpointTheme) {
                        $scope.logo = imagesRoot.img('checkpoint-logo.png');
                    } else if (feature.lastlineTheme) {
                        $scope.logo = imagesRoot.img('lastline-logo-white.png');
                    } else if (feature.sonicwallTheme) {
                        $scope.logo = imagesRoot.img('sonicwall-logo-white.png');
                    } else {
                        $scope.tryCustomLogo = true;
                        $scope.logo = imagesRoot.img('logo-white.svg');
                    }
                });
            }
        };
    }]);
}());